import Vue from "vue";
import { $http } from "@/assets/js/appFunc";
import i18n from "@/i18n";

export const getCurrentActivityTasks = (store, data) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    return new Promise((resolve, reject) => {
        $http({
            url: `/engine/api/liveView/task/details/by/activity/${data.info.uuid}/processDefinition/${applicationId}`,
            type: "POST",
            data: data.data
        }, true).then(rsp => {
            store.commit("setSelectedTaskDetails", rsp.data);
            resolve(rsp.data);
        }).catch(e => {
            reject(e);
        });
    });
};

export const actionGetAllTasks = (store, { data, pageType, activeTab }) => {
    let url;
    if (pageType === "searchPerspectives") {
        const applicationId = store.rootGetters["main/getCurrentApplicationId"];
        const { perspectiveId, id: processDefinitionId } = store.rootGetters["reports/getSelectedProcessReports"][pageType];
        url = `/engine/apps/${applicationId}/consume/perspectives/${perspectiveId}/stats/processDefinition/${processDefinitionId}`;
    } else {
        const processId = activeTab === "tasks"
            ? store.rootGetters["reports/getSelectedProcessReports"][pageType].id : store.rootGetters["reports/getSelectedProcessStatistics"].id;

        url = `/engine/api/liveView/activity/stats/by/processDefinition/${processId}`;
    }
    const params = {
        url,
        type: "POST",
        data
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            rsp => {
                const payload2 = rsp.data || rsp;
                store.commit("setFilteredData", payload2);
                resolve(payload2);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getActivityReportsTasks = (store, { pageType, taskPayload }) => {
    let url;
    const isPerspective = pageType === "searchPerspectives";
    if (isPerspective) {
        const { perspectiveId } = store.rootGetters["reports/getSelectedProcessReports"][pageType];
        url = `/engine/apps/consume/perspectives/${perspectiveId}/activity/stats/by/processDefinition/filter`;
    } else {
        url = "/engine/api/liveView/activity/stats/by/processDefinition/filter";
    }

    const params = {
        url,
        type: "POST",
        data: taskPayload,
        noNotify: true
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                const payload = data.data ? data.data : data;
                resolve(payload);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const saveReportsFilter = (context, payload) => {
    let url = `/engine/task/settings/${payload.processDefinitionId}/${payload.interfaceData.interfaceName}`;
    if (payload.perspectiveCase) {
        url = `/engine/task/settings/${payload.processDefinitionId}/perspectives?perspectiveId=${payload.perspectiveId}&appId=${payload.appId}`;
        delete payload.interfaceData.interfaceName;
    }
    const params = {
        url,
        type: "POST",
        data: payload.interfaceData,
        noNotify: true
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const favoriteReportsFilters = (context, setup) => {
    let url = `/engine/task/settings/filter/${setup.id}/favorite`;
    if (setup.perspectiveCase) {
        url += `/perspectives?perspectiveId=${setup.perspectiveId}&appId=${setup.appId}`;
    }
    const params = {
        url,
        type: "POST"
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                const payload = data.data ? data.data : data;
                resolve(payload);
            },
            error => {
                reject(error);
            }
        );
    });
};
export const getAllSavedFilters = (store, payload) => {
    let url = `/engine/task/settings/${payload.processDefinitionId}/${payload.interfaceName}/all`;
    if (payload.perspectiveCase) {
        url = `/engine/task/settings/${payload.processDefinitionId}/all/perspectives?perspectiveId=${payload.perspectiveId}&appId=${payload.appId}`;
    }
    const params = {
        url,
        type: "GET"
    };

    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                resolve(data.data || data);
            },
            error => {
                reject(error);
            }
        );
    });
};
export const getAllReportsActivities = (store, payload) => {
    const params = {
        url: `/engine/api/liveView/activities/processDefinition/${payload} `,
        type: "GET"
    };

    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                const response = data.data || data;
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const generateFilterLink = (store, payload) => {
    let url = `/engine/task/settings/filter/${payload.id}/processDefinition/${payload.processDefinitionId}/link`;
    if (payload.perspectiveCase) {
        url += `/perspectives?perspectiveId=${payload.perspectiveId}&appId=${payload.appId}`;
    }
    const params = {
        url,
        type: "GET"
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                const result = data.data || data;
                resolve(result);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const sendShareFilterMail = (store, payload) => {
    let url = "/engine/task/settings/filter/share";
    if (payload.perspectiveCase) {
        url += `/perspectives?perspectiveId=${payload.perspectiveId}&appId=${payload.appId}`;
    }
    const params = {
        url,
        type: "POST",
        data: payload.filterSetup
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                const result = data.data || data;
                resolve(result);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const searchAllUsersGroups = (store, payload) => {
    const params = {
        url: "/identity/user-group/ids",
        type: "POST",
        data: payload
    };

    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                const response = data.data || data;
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getAllFavoritesFilters = (store, payload) => {
    let url = `/engine/task/settings/${payload.processDefinitionId}/${payload.interfaceName}/favorite`;
    if (payload.perspectiveCase) {
        url = `/engine/task/settings/${payload.processDefinitionId}/favorite/perspectives?perspectiveId=${payload.perspectiveId}&appId=${payload.appId}`;
    }
    const params = {
        url,
        type: "GET"
    };

    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                resolve(data.data || data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const exportReportsTasksInstances = (store, { pageType, payload }) => {
    let url;

    if (pageType === "searchPerspectives") {
        const { perspectiveId } = store.rootGetters["reports/getSelectedProcessReports"][pageType];
        url = `/engine/apps/consume/perspectives/${perspectiveId}/${payload.isTask ? "tasks" : "processInstance"}/queue/export`;
    } else {
        url = `/engine/api/liveView/queue/reports/${payload.isTask ? "exportTasks" : "exportInstances"}`;
    }

    const params = {
        url,
        type: "POST",
        data: payload
    };

    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                const result = data.data ? data.data : data;
                resolve(result);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getReportsFilterUsers = (store, payload) => {
    const params = {
        type: "POST",
        url: "/identity/tenants/share-filters/users",
        data: payload
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                const result = data.data || data;
                resolve(result);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const cancelReportsExport = (store, payload) => {
    const exportType = payload.typeTask ? "TASK" : "INST";
    const params = {
        url: `/engine/api/liveView/queue/reports/cancel/${payload.currentProcessId}/${exportType}`,
        type: "POST"
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                const result = data.data || data;
                resolve(result);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getFilter = (store, payload) => {
    let url = `/engine/task/settings/filter/${payload.id}/processDefinition/${payload.processDefinitionId}`;
    if (payload.perspectiveCase) {
        url += `/perspectives?perspectiveId=${payload.perspectiveId}&appId=${payload.appId}`;
    }
    const params = {
        url,
        type: "GET",
        noNotify: true
    };

    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                resolve(data.data || data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const deleteReportsFilters = (store, payload) => {
    let url = "/engine/task/settings/filter";
    if (payload.perspectiveCase) {
        url += `/perspectives?perspectiveId=${payload.perspectiveId}&appId=${payload.appId}`;
    }
    const params = {
        url,
        type: "POST",
        data: payload.filtersList
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                const response = data.data || data;
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
};
// timeline AuditTrail
// return task details on timeline per stage
export const getTimeLineStageDetails = (store, data) => {
    const params = {
        url: `/engine/api/liveView/activity/stats/by/processDefinition/${data.taskId}`,
        type: "GET"
    };

    return new Promise((resolve) => {
        $http(params, true).then(
            rsp => {
                const payload = rsp.data ? rsp.data : rsp;
                resolve(payload);
            }
        );
    });
};
export const getTaskInformation = (context, payload) => {
    const { taskId } = context.rootState.main;
    let url = `/engine/task/get/by/${taskId}`;
    if (payload && payload.perspectiveId) {
        url = `/engine/tasks/${taskId}?appId=${payload.appId}&perspectiveId=${payload.perspectiveId}`;
    }
    const req = {
        type: "GET",
        url
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            rsp => {
                context.commit("setTaskDetailsById", rsp);
                resolve(rsp);
            },
            error => {
                reject(error);
            }
        );
    });
};

// get task information if user has permissions for current dataView
export const getTaskInfoUsingPerspective = (context, payload) => {
    const { taskId, applicationId, dataViewsId } = payload;
    const req = {
        type: "GET",
        url: `/engine/tasks/${taskId}?appId=${applicationId}&perspectiveId=${dataViewsId}`,
        noNotify: true
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            rsp => {
                resolve(rsp.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

// Get statistics per activity
export const getStatsPerActivity = (store, dataToSend) => new Promise((resolve, reject) => {
    $http({
        url: "/stats/api/activity/tat",
        type: "POST",
        data: dataToSend
    }, true).then(rsp => {
        resolve(rsp);
    }).catch(e => {
        reject(e);
    });
});

// Get statistics per process
export const getStatsPerProcess = (store, dataToSend) => new Promise((resolve, reject) => {
    $http({
        url: "/stats/api/processdefinition/tat",
        type: "POST",
        data: dataToSend
    }, true).then(rsp => {
        resolve(rsp);
    }).catch(e => {
        reject(e);
    });
});

// Get statistics per levels - app matrix
export const getStatsPerLvlsAppMatrix = (store, dataToSend) => new Promise((resolve, reject) => {
    $http({
        url: "/stats/api/activity/matrix/tat",
        type: "POST",
        data: dataToSend
    }, true).then(rsp => {
        store.commit("setStatsPerLevels", rsp.data);
        resolve(rsp);
    }).catch(e => {
        reject(e);
    });
});

export const getAppMatrixUncompletedTasksInfo = (context, data) => {
    const parentActivityId = data;
    const req = {
        type: "GET",
        url: `/engine/api/liveView/task/stats/by/level/${parentActivityId}`
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            rsp => {
                context.commit("setAppMatrixUncompletedTasksInfo", rsp.data);
                resolve(rsp);
            },
            error => {
                reject(error);
            }
        );
    });
};

// new functionality

export const getAllTasks = (store, { pageType, payload }) => {
    let url;
    const isPerspective = pageType === "searchPerspectives";

    if (isPerspective) {
        const { perspectiveId } = store.rootGetters["reports/getSelectedProcessReports"][pageType];
        url = `/engine/apps/consume/perspectives/${perspectiveId}/tasks`;
    } else {
        url = "/engine/task/reports";
    }
    const req = {
        type: "POST",
        url,
        data: payload,
        noNotify: true
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getAllInstances = (store, { pageType, payload }) => {
    let url;
    const isPerspective = pageType === "searchPerspectives";

    if (isPerspective) {
        const { perspectiveId } = store.rootGetters["reports/getSelectedProcessReports"][pageType];
        url = `/engine/apps/consume/perspectives/${perspectiveId}/processInstance`;
    } else {
        url = "/engine/api/processInstance/reports";
    }
    const req = {
        type: "POST",
        url,
        data: payload,
        noNotify: true
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getGuiItemDetails = (context, data) => {
    let url;
    if (data.perspectiveId) {
        const customUrl = `/engine/apps/${data.appId}/consume/perspectives/${data.perspectiveId}/processInstances/${data.instanceId}/view`;
        if (data.endActivityId) {
            url = `${customUrl}?endActivityId=${data.endActivityId}`;
        } else {
            url = customUrl;
        }
    } else {
        url = `/engine/task/view/by/activity/${data.endActivityId}/processInstance/${data.instanceId}`;
    }
    const req = {
        type: "GET",
        url,
        noNotify: true
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getTasksTotalCounter = (store, { pageType, payload }) => {
    let url;
    const isPerspective = pageType === "searchPerspectives";
    if (isPerspective) {
        const { perspectiveId } = store.rootGetters["reports/getSelectedProcessReports"][pageType];
        url = `/engine/apps/consume/perspectives/${perspectiveId}/tasks/count`;
    } else {
        url = "/engine/task/reports/count";
    }
    const req = {
        type: "POST",
        url,
        data: payload,
        noNotify: true
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                const response = data && data.data && data.data.count ? data.data.count : 0;
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getInstancesTotalCounter = (store, { pageType, payload }) => {
    let url;
    const isPerspective = pageType === "searchPerspectives";

    if (isPerspective) {
        const { perspectiveId } = store.rootGetters["reports/getSelectedProcessReports"][pageType];
        url = `/engine/apps/consume/perspectives/${perspectiveId}/processInstance/count`;
    } else {
        url = "/engine/api/processInstance/reports/count";
    }
    const req = {
        type: "POST",
        url,
        data: payload,
        noNotify: true
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                const response = data && data.data && data.data.count ? data.data.count : 0;
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getItemsOnBulk = (context, payload) => {
    const req = {
        type: "POST",
        url: "/engine/task/ids/reports/bulk",
        data: payload
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data || []);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const saveReportsSortPreferences = (context, data) => {
    let url = `/engine/task/settings/${data.processId}/${data.data.interfaceName}`;
    if (data.data.perspectiveId) {
        url = `/engine/task/settings/${data.processId}/perspectives/${data.data.perspectiveId}/${data.data.interfaceName}?appId=${data.data.appId}`;
    }
    const req = {
        type: "POST",
        url,
        data: data.data.contentData,
        noNotify: true
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getReportsSortPreferences = (context, payload) => {
    const processDefinitionId = context.rootGetters["reports/getSelectedProcessReports"][payload.pageType].id;
    let url = `/engine/task/settings/${processDefinitionId}/${payload.interfaceName}`;
    if (payload.perspectiveId) {
        url = `/engine/task/settings/${processDefinitionId}/perspectives/${payload.perspectiveId}/${payload.interfaceName}?appId=${payload.appId}`;
    }
    const req = {
        type: "GET",
        url,
        noNotify: true
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getReportsTaskAssignees = (context, taskId) => {
    const req = {
        type: "GET",
        url: `/engine/task/${taskId}/assignees`,
        noNotify: true
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

// end

export const exportInstanceFilters = (store, dataRequest) => {
    const params = {
        url: "/engine/api/liveView/queue/reports/export",
        type: "POST",
        dataRequest,
        noNotify: true
    };
    return new Promise((resolve) => {
        $http(params, true).then(
            data => {
                const payload = data.data ? data.data : data;
                store.commit("setFilteredInstances", data.data);
                resolve(payload);
                Vue.prototype.$toast.showNotify({
                    message: i18n.t("liveView.filters.export.toastMsg"),
                    timeout: 5000,
                    type: "success"
                });
            }
        )
            .catch(error => {
                let errorMessage = "";
                const { status } = error.response;
                if (status === 409) {
                    errorMessage = i18n.t("liveView.filters.export.err409");
                } else if (status === 400) {
                    errorMessage = i18n.t("liveView.filters.export.err400");
                } else if (status === 500) {
                    if (error.response.data.error === "No task data is available") {
                        errorMessage = i18n.t("liveView.filters.export.err500");
                    } else {
                        errorMessage = i18n.t("liveView.filters.export.err5001");
                    }
                } else if (status === 404) {
                    errorMessage = i18n.t("liveView.filters.export.err404");
                } else {
                    errorMessage = i18n.t("liveView.filters.export.errorGen");
                }
                Vue.prototype.$toast.showNotify({
                    message: errorMessage,
                    timeout: 5000,
                    type: (status === 400 || status === 409) ? "warning" : "error"
                });
            });
    });
};

export const actDownloadExportedFile = (store, { fileName, type }) => {
    let urlToSend = `/engine/api/export/reports/xlsx?fileName=${fileName}`;
    if (type === "GDM") {
        urlToSend = `/globaldata/download/xlsx/${fileName}`;
    } else if (type === "LOG") {
        urlToSend = `/audit/download/csv/${fileName}`;
    } else if (type === "DS") {
        urlToSend = `/datastore/csv/download/report/${fileName}`;
    } else if (type === "DS_EXPORT") {
        urlToSend = `/datastore/csv/download/export/${fileName}`;
    }
    const params = {
        type: "GET",
        url: urlToSend,
        responseType: "arraybuffer",
        noNotify: true,
        headers: {
            "Content-type": "application/json;charset=UTF-8",
            Accept: "application/octet-stream"
        }
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
};
